export default __webpack_public_path__ + "static/media/calendar.2fdf3c39.svg";